import React, { Component } from "react";
import { Spin, Form, Modal, Select, Tag } from "antd";
import UserSearchForm from "../../User/user-search-form";

class WhiteListUrlEntryModal extends Component {
  state = {
    memberList: [],
  };

  componentDidUpdate = async (prevProps) => {
    const { data: pd } = prevProps;
    const { data: d, form, isModify } = this.props;

    if (d && d.id !== pd.id && isModify) {
      form.setFieldsValue(d);
      this.setState({
        memberList: [
          {
            member_id: d.member_id,
            email: d.email,
            value: d.value,
            status: d.status,
            configuration_id: d.configuration_id,
          },
        ],
      });
    }
  };

  handleCancelModal = () => {
    const { onCancel, form } = this.props;

    form.resetFields();
    onCancel();
  };

  handleCallbackMember = (val) => {
    const { form } = this.props;
    form.setFieldsValue({ member_id: val });
  };

  render() {
    const { visible, onCreate, form, isModify, loading, existingData } =
      this.props;
    const { getFieldDecorator } = form;
    const okText = isModify ? "Edit" : "Add";
    const title = `${okText} Member Whitelist URL`;

    return (
      <Modal
        cancelText="Cancel"
        maskClosable={false}
        okText={okText}
        onCancel={this.handleCancelModal}
        onOk={() => onCreate(form)}
        style={{ top: 20 }}
        title={title}
        visible={visible}
      >
        <Spin spinning={loading} tip="Loading...">
          <Form className="whitelist-url">
            <Form.Item label="Member">
              {getFieldDecorator("member_id", {
                rules: [
                  {
                    message: "Please select member",
                    required: true,
                  },
                ],
              })(
                <UserSearchForm
                  valueCallback={this.handleCallbackMember}
                  memberList={this.state.memberList}
                  existList={existingData}
                  isModify={isModify}
                  value={form.getFieldValue("member_id")}
                />
              )}
            </Form.Item>
            <Form.Item label="Value">
              {getFieldDecorator("value", {
                rules: [
                  {
                    message: "Select the value",
                    required: true,
                  },
                ],
              })(
                <Select>
                  <Select.Option value={"inactive"}>
                    <Tag color="red">Not Allowed</Tag>
                  </Select.Option>
                  <Select.Option value={"active"}>
                    <Tag color="green">Allowed</Tag>
                  </Select.Option>
                </Select>
              )}
            </Form.Item>
            <Form.Item label="Status">
              {getFieldDecorator("status", {
                rules: [
                  {
                    message: "Select the value",
                    required: true,
                  },
                ],
              })(
                <Select>
                  <Select.Option value={"enabled"}>
                    <Tag color="green">Enabled</Tag>
                  </Select.Option>
                  <Select.Option value={"disabled"}>
                    <Tag color="red">Disabled</Tag>
                  </Select.Option>
                  <Select.Option value={"deleted"}>
                    <Tag color="grey">Deleted</Tag>
                  </Select.Option>
                </Select>
              )}
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

export default Form.create({ name: "whitelist-url" })(WhiteListUrlEntryModal);



// WEBPACK FOOTER //
// ./src/containers/Keyword/WhitelistURL/entry-modal.js